export default "__VITE_ASSET__d51ce211__"